import { render, staticRenderFns } from "./DialogMeusParcelamentos.vue?vue&type=template&id=52381b07&scoped=true"
import script from "./DialogMeusParcelamentos.vue?vue&type=script&lang=js"
export * from "./DialogMeusParcelamentos.vue?vue&type=script&lang=js"
import style0 from "./DialogMeusParcelamentos.vue?vue&type=style&index=0&id=52381b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52381b07",
  null
  
)

export default component.exports